<template>
    <ModalBase
        :name="modalName"
        :title="documento?.nombre || 'Documento'"
        width="1200"
        @close="close"
    >
        <div class="tw:flex tw:flex-col tw:items-center tw:gap-4 tw:bg-gray-50 tw:rounded-lg tw:p-2">
            <img
                v-if="documento?.url"
                :src="documento.url"
                :alt="documento.nombre"
                class="tw:max-w-full tw:max-h-[85vh] tw:rounded tw:object-contain tw:shadow-sm"
            />
            <p v-else class="tw:text-sm tw:text-gray-500">
                No hay imagen disponible para previsualizar.
            </p>
        </div>
        <template #footer>
            <div class="tw:flex tw:justify-end tw:gap-2">
                <Button variant="ghost" @click="close">Cerrar</Button>
                <Button
                    v-if="documento?.url"
                    variant="primary"
                    :disabled="loading"
                    @click="onDownload"
                >
                    <i class="fas fa-download tw:mr-1"></i>
                    {{ loading ? 'Descargando...' : 'Descargar' }}
                </Button>
            </div>
        </template>
    </ModalBase>
</template>

<script setup>
    import { computed, getCurrentInstance } from 'vue';
    import ModalBase from '@/modules/admin/ui/ModalBase.vue';
    import Button from '@/modules/admin/ui/Button.vue';

    const props = defineProps({
        documento: {
            type: Object,
            default: null,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    });

    const emit = defineEmits(['close', 'download']);

    const instance = getCurrentInstance();

    const modalName = computed(() => `view-documento-${props.documento?.id ?? 'nuevo'}`);

    function close() {
        instance.proxy.$modal.hide(modalName.value);
        emit('close');
    }

    function onDownload() {
        if (!props.documento?.url || props.loading) return;
        emit('download', props.documento);
    }
</script>